import { Pipe, PipeTransform, inject } from '@angular/core';
import { DataService } from '../../services/data.service';

@Pipe({
  standalone: true,
  name: 'Date',
  pure: true,
})
export class DatePipe implements PipeTransform {
  private dataService = inject(DataService);

  /**
   * Transforms a date string into a formatted date based on the application's current language.
   * Optionally includes the time in the formatted output.
   *
   * @param date - The date string to be formatted.
   * @param includeTime - Whether to include the time portion in the formatted result.
   * @returns {string} - The formatted date string.
   */
  public transform(date: string, includeTime: boolean = false): string {
    return this.dataService.formatDate(date, includeTime);
  }
}
